import api from 'data/api';

export const loadPeriods = api('GET /api/mobile/lookups/periods');
